import { toast } from "react-toastify"
import { TallyConfig } from "../helpers/constants"
import * as moment from "moment"
import { xmlFormatter } from "../helpers/xmlFormatter"



export async function CreatePaymentReceipt({payment, bankAccount, company, voucherType}){

    let dealer = payment?.dealerId || []

    if(!(dealer instanceof Array)){
        dealer = [dealer]
    }

    if(!voucherType && voucherType===""){
        voucherType = "Receipt"
    }else {
        voucherType = voucherType?._attributes?.NAME
    }

    dealer = dealer[0]

    if(!dealer){
        toast.error("Dealer not found")
        return false
    }

    let date = payment?.createdAt
    // date as 20240401 format
    date = moment(date).format("YYYYMMDD")

    // TODO: DEV
    if(process.env.REACT_APP_ELECTRON_ENV === 'DEV'){
        date = "20240401"
    }

    let data = `
        <ENVELOPE>
            <HEADER>
                <TALLYREQUEST>Import Data</TALLYREQUEST>
            </HEADER>
            <BODY>
                <IMPORTDATA>
                    <REQUESTDESC>
                        <REPORTNAME>Vouchers</REPORTNAME>
                        <STATICVARIABLES>
                            <SVCURRENTCOMPANY>${company!=="" ? company : TallyConfig.company}</SVCURRENTCOMPANY>
                        </STATICVARIABLES>
                    </REQUESTDESC>
                    <REQUESTDATA>
                        <TALLYMESSAGE xmlns:UDF="TallyUDF">
                            <VOUCHER VCHTYPE="${voucherType}" OBJVIEW="Accounting Voucher View">
                                <VATREGISTRATIONDATE/>
                                <CSTREGISTRATIONDATE/>
                                <DATE>${date}</DATE>
                                <VCHSTATUSDATE>${date}</VCHSTATUSDATE>
                                <PARTYNAME/>
                                <RETURNNAME/>
                                <VOUCHERTYPENAME>${voucherType}</VOUCHERTYPENAME>
                                <ECOMMERCEGSTIN/>
                                <PARTYLEDGERNAME>${dealer?.name}</PARTYLEDGERNAME>
                                <TAXADJUSTMENT/>
                                <BUYERADDRESSTYPE/>
                                <NUMBERINGSTYLE>Auto Retain</NUMBERINGSTYLE>
                                <FBTPAYMENTTYPE>Default</FBTPAYMENTTYPE>
                                <PERSISTEDVIEW>Accounting Voucher View</PERSISTEDVIEW>
                                <VCHSTATUSTAXADJUSTMENT>Default</VCHSTATUSTAXADJUSTMENT>
                                <ISMSTFROMSYNC>No</ISMSTFROMSYNC>
                                <ISDELETED>No</ISDELETED>
                                <ISSECURITYONWHENENTERED>No</ISSECURITYONWHENENTERED>
                                <ASORIGINAL>No</ASORIGINAL>
                                <ISDEEMEDPOSITIVE TYPE="Logical">No</ISDEEMEDPOSITIVE>
                                <ISOPTIONAL>No</ISOPTIONAL>
                                <EFFECTIVEDATE>${date}</EFFECTIVEDATE>
                                <USEFORSERVICETAX>No</USEFORSERVICETAX>
                                <ISREVERSECHARGEAPPLICABLE>No</ISREVERSECHARGEAPPLICABLE>
                                <ISSYSTEM>No</ISSYSTEM>
                                <ISCANCELLED>No</ISCANCELLED>
                                <ISONHOLD>No</ISONHOLD>
                                <ISSUMMARY>No</ISSUMMARY>
                                <ISELIGIBLEFORITC>Yes</ISELIGIBLEFORITC>
                                <UPDATESUMMARYVALUES>No</UPDATESUMMARYVALUES>
                                <ISEWAYBILLAPPLICABLE>No</ISEWAYBILLAPPLICABLE>
                                <ISDELETEDRETAINED>No</ISDELETEDRETAINED>
                                <ISNULL>No</ISNULL>
                                <ISINVOICE>No</ISINVOICE>
                                <ISNEGISPOSSET TYPE="Logical">Yes</ISNEGISPOSSET>
                                <VCHPROPDELETED TYPE="Logical">No</VCHPROPDELETED>
                                <VCHPROPISSTKJRNL TYPE="Logical">No</VCHPROPISSTKJRNL>
                                <VCHPROPCURNEGISPOS TYPE="Logical">No</VCHPROPCURNEGISPOS>
                                <RESETIRNQRCODE>No</RESETIRNQRCODE>
                                <ISVCHFROMSPLIT>No</ISVCHFROMSPLIT>
                                <VOUCHERNUMBERSERIES>Default</VOUCHERNUMBERSERIES>
                                <TEMPFROMDATE/>
                                <ALLLEDGERENTRIES.LIST>
                                    <ORIGPURCHINVDATE/>
                                    <NARRATION>${parseFloat(payment?.amount).toFixed(2)} received from ${dealer?.name} ${(payment?.remark && payment?.remark!=="") ? "(" + payment?.remark + ")" : ""}</NARRATION>
                                    <ADDLALLOCTYPE/>
                                    <TAXCLASSIFICATIONNAME/>
                                    <LEDGERNAME>${dealer?.name}</LEDGERNAME>
                                    <ORIGPURCHINVNO/>
                                    <ORIGPURCHNOTE/>
                                    <ISDEEMEDPOSITIVE>No</ISDEEMEDPOSITIVE>
                                    <ISPARTYLEDGER>Yes</ISPARTYLEDGER>
                                    <AMOUNT>${parseFloat(payment?.amount).toFixed(2)}</AMOUNT>
                                </ALLLEDGERENTRIES.LIST>
                                <ALLLEDGERENTRIES.LIST>
                                    <LEDGERNAME>${bankAccount?._attributes?.NAME}</LEDGERNAME>
                                    <ISDEEMEDPOSITIVE>Yes</ISDEEMEDPOSITIVE>
                                    <ISPARTYLEDGER>Yes</ISPARTYLEDGER>
                                    <ISACCEPTASIS/>
                                    <AMOUNT>-${parseFloat(payment?.amount).toFixed(2)}</AMOUNT>
                                    <BANKALLOCATIONS.LIST>
                                        <DATE>${date}</DATE>
                                        <INSTRUMENTDATE>${date}</INSTRUMENTDATE>
                                        <PAYMENTFAVOURING>${dealer?.name}</PAYMENTFAVOURING>
                                        <SECONDARYSTATUS/>
                                        <BANKEMPLOYEENAME/>
                                        <AMOUNT>-${parseFloat(payment?.amount).toFixed(2)}</AMOUNT>
                                    </BANKALLOCATIONS.LIST>
                                </ALLLEDGERENTRIES.LIST>
                            </VOUCHER>
                        </TALLYMESSAGE>
                    </REQUESTDATA>
                </IMPORTDATA>
            </BODY>
        </ENVELOPE>
    
    `


    data = xmlFormatter(data)

    try {
        let resp = await window.electron.tallyConnect({
            url: `${TallyConfig.host}:${TallyConfig.port}`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/xml',
            },
            timeout: 500000,
            data: data
        })
        if (resp.status === 200) {
            let jsonData = resp?.data

            if (jsonData?.RESPONSE?.CREATED?._text === "1") {
                let voucherId = jsonData?.RESPONSE?.LASTVCHID?._text
                return voucherId
            }else{
                return false
            }
        } else {
            return false
        }
    } catch (err) {
        return false
    }
}